import { render, staticRenderFns } from "./ManagerSelectorsInput.vue?vue&type=template&id=12dd5910&"
import script from "./ManagerSelectorsInput.vue?vue&type=script&lang=ts&"
export * from "./ManagerSelectorsInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports